import React from "react";
import Hero from "@/components/sections/Hero";
import StatsBar from "@/components/sections/StatsBar";
import ServicesShowcase from "@/components/sections/ServicesShowcase";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import GalleryPreview from "@/components/sections/GalleryPreview";
import ProcessSection from "@/components/sections/ProcessSection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import FinalCTA from "@/components/sections/FinalCTA";

const HomePage = () => {
  return (
    <div data-testid="home-page">
      <Hero />
      <StatsBar />
      <ServicesShowcase />
      <WhyChooseUs />
      <GalleryPreview />
      <ProcessSection />
      <TestimonialsSection />
      <FinalCTA />
    </div>
  );
};

export default HomePage;
